// This function converts a string to simple letters (ignores diacritics, like in űáéőúóüöí)
if (!String.prototype.toSimpleLetters) {
  Object.defineProperty(String.prototype, "toSimpleLetters", {
    value: function () {
      return this.normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim();
    },
    writable: false,
  });
}
